export const COUNTRIES = [
    { code: 'IN', name: 'India', currency: '₹', currencyCode: 'INR' },
    { code: 'US', name: 'United States', currency: '$', currencyCode: 'USD' },
    { code: 'UK', name: 'United Kingdom', currency: '£', currencyCode: 'GBP' },
    { code: 'EU', name: 'Europe (Eurozone)', currency: '€', currencyCode: 'EUR' },
    { code: 'AE', name: 'UAE', currency: 'AED', currencyCode: 'AED' },
    { code: 'AU', name: 'Australia', currency: 'A$', currencyCode: 'AUD' },
    { code: 'CA', name: 'Canada', currency: 'C$', currencyCode: 'CAD' },
    { code: 'SG', name: 'Singapore', currency: 'S$', currencyCode: 'SGD' },
    { code: 'ZA', name: 'South Africa', currency: 'R', currencyCode: 'ZAR' },
    { code: 'JP', name: 'Japan', currency: '¥', currencyCode: 'JPY' },
    { code: 'CN', name: 'China', currency: '¥', currencyCode: 'CNY' },
    { code: 'CH', name: 'Switzerland', currency: 'CHF', currencyCode: 'CHF' },
    { code: 'HK', name: 'Hong Kong', currency: 'HK$', currencyCode: 'HKD' },
    { code: 'NZ', name: 'New Zealand', currency: 'NZ$', currencyCode: 'NZD' },
    { code: 'KR', name: 'South Korea', currency: '₩', currencyCode: 'KRW' },
    { code: 'SA', name: 'Saudi Arabia', currency: 'SAR', currencyCode: 'SAR' },
    { code: 'BR', name: 'Brazil', currency: 'R$', currencyCode: 'BRL' },
    { code: 'MX', name: 'Mexico', currency: '$', currencyCode: 'MXN' },
    { code: 'TR', name: 'Turkey', currency: '₺', currencyCode: 'TRY' },
    { code: 'SE', name: 'Sweden', currency: 'kr', currencyCode: 'SEK' },
    { code: 'NO', name: 'Norway', currency: 'kr', currencyCode: 'NOK' },
    { code: 'DK', name: 'Denmark', currency: 'kr', currencyCode: 'DKK' },
    { code: 'MY', name: 'Malaysia', currency: 'RM', currencyCode: 'MYR' },
    { code: 'TH', name: 'Thailand', currency: '฿', currencyCode: 'THB' },
    { code: 'ID', name: 'Indonesia', currency: 'Rp', currencyCode: 'IDR' },
    { code: 'QA', name: 'Qatar', currency: 'QAR', currencyCode: 'QAR' },
    { code: 'OM', name: 'Oman', currency: 'OMR', currencyCode: 'OMR' },
    { code: 'KW', name: 'Kuwait', currency: 'KWD', currencyCode: 'KWD' },
    { code: 'BH', name: 'Bahrain', currency: 'BHD', currencyCode: 'BHD' },
    { code: 'LK', name: 'Sri Lanka', currency: 'Rs', currencyCode: 'LKR' }
];

export const getCurrencyCodeByCountry = (countryName?: string | null): string => {
    if (!countryName) return 'INR';
    const c = countryName.toLowerCase().trim();
    
    // Check direct matches first
    const found = COUNTRIES.find(curr => 
        curr.name.toLowerCase() === c || 
        curr.code.toLowerCase() === c
    );
    if (found) return found.currencyCode;
    
    // Fuzzy matching for common regions and specific countries not in COUNTRIES list
    if (c.includes('united states') || c.includes('usa') || c === 'us') return 'USD';
    if (c.includes('united kingdom') || c.includes('uk') || c === 'gb') return 'GBP';
    if (c.includes('emirates') || c.includes('uae')) return 'AED';
    if (
        c.includes('europe') || 
        c.includes('germany') || 
        c.includes('france') || 
        c.includes('italy') || 
        c.includes('spain') || 
        c.includes('netherlands') ||
        c === 'eu'
    ) return 'EUR';
    
    // Try to find by code if the input was an ISO code
    if (c.length === 2) {
        const byCode = COUNTRIES.find(curr => curr.code.toLowerCase() === c);
        if (byCode) return byCode.currencyCode;
    }

    return 'USD'; // Global Fallback
};

export const getCurrencySymbol = (countryName?: string | null) => {
    const code = getCurrencyCodeByCountry(countryName);
    const found = COUNTRIES.find(c => c.currencyCode === code);
    if (found) return found.currency;
    
    try {
        return (0).toLocaleString('en-US', { style: 'currency', currency: code }).replace(/\d|\s|\./g, '');
    } catch {
        return code === 'INR' ? '₹' : '$';
    }
};

export const formatCurrency = (amount: number, countryName?: string | null) => {
    const code = getCurrencyCodeByCountry(countryName);
    return new Intl.NumberFormat(code === 'INR' ? 'en-IN' : 'en-US', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: code === 'INR' ? 0 : 2
    }).format(amount);
};

